import React, { Component } from "react";
import getEventDetails from "../../services/getEventDetails";
import updateConfermaEvento from "../../services/updateConfermaEvento";
import updateRifiutaEvento from "../../services/updateRifiutaEvento";
import updateListaEvento from "../../services/updateListaEvento";
import updateRemoveListaEvento from "../../services/updateRemoveListaEvento";
import getCountPartecipanti from "../../services/getCountPartecipanti";

class EventResponse extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      descrizione: null,
      locandina: null,
      orario: null,
      titolo: null,
      n_partecipanti: null,
      partecipa: null,
      n_partecipanti_max: null,
      isLoading: true,
      lista_attesa: null,
    };
  }

  async componentDidMount() {
    await this.fetchEventDetails();
  }

  fetchEventDetails = async () => {
    const urlParams = new URLSearchParams(window.location.hash.split("?")[1]);
    const token = urlParams.get("token");

    try {
      const eventDetails = await getEventDetails(token);

      const eventData = eventDetails[0];

      console.log("eventData", eventData);

      const countPartecipanti = await getCountPartecipanti(eventData.id);

      const nPartecipantiEffettivi = countPartecipanti.count;

      this.setState({
        token,
        data: eventData.data,
        descrizione: eventData.descrizione,
        locandina: eventData.locandina,
        orario: eventData.orario,
        titolo: eventData.titolo,
        n_partecipanti_max: eventData.n_partecipanti,
        partecipa: eventData.partecipa,
        isLoading: false,
        nome: eventData.studente_nome,
        lista_attesa: eventData.lista_attesa,
        cognome: eventData.studente_cognome,
        n_partecipanti: nPartecipantiEffettivi,
      });
    } catch (error) {
      console.error("Errore nel recupero dei dettagli dell'evento:", error);
      this.setState({ isLoading: false });
    }
  };

  handleAccept = async () => {
    const { token } = this.state;

    try {
      await updateConfermaEvento(token);
      alert("Invito accettato correttamente!");
      await this.fetchEventDetails();
    } catch (error) {
      console.error("Errore nell'aggiornamento dell'invito:", error);
      alert("Si è verificato un errore. Riprova.");
    }
  };

  handleReject = async () => {
    const { token } = this.state;

    try {
      await updateRifiutaEvento(token);
      alert("Invito rifiutato correttamente!");
      await this.fetchEventDetails();
    } catch (error) {
      console.error("Errore nell'aggiornamento dell'invito:", error);
      alert("Si è verificato un errore. Riprova.");
    }
  };

  handleLista = async () => {
    const { token } = this.state;

    try {
      await updateListaEvento(token);
      alert("Inserito in lista correttamente!");
      await this.fetchEventDetails();
    } catch (error) {
      console.error("Errore nell'inserimento in lista:", error);
      alert("Si è verificato un errore. Riprova.");
    }
  };

  handleRemoveLista = async () => {
    const { token } = this.state;

    try {
      await updateRemoveListaEvento(token);
      alert("Rimosso dalla lista d'attesa correttamente!");
      await this.fetchEventDetails();
    } catch (error) {
      console.error("Errore nell'inserimento in lista:", error);
      alert("Si è verificato un errore. Riprova.");
    }
  };

  render() {
    const {
      data,
      descrizione,
      locandina,
      orario,
      titolo,
      partecipa,
      isLoading,
      nome,
      n_partecipanti,
      n_partecipanti_max,
      lista_attesa,
    } = this.state;

    const styles = {
      container: {
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f4f4f4",
        padding: "20px",
        color: "#333",
        textAlign: "center",
        height: "100vh",
      },
      table: {
        maxWidth: "600px",
        width: "100%",
        backgroundColor: "#ffffff",
        border: "1px solid #ddd",
        borderRadius: "8px",
        margin: "0 auto",
        padding: "20px",
      },
      heading: {
        color: "#e72424",
        fontSize: "24px",
        marginBottom: "10px",
      },
      subHeading: {
        fontSize: "18px",
        color: "#555",
      },
      buttonContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        marginTop: "20px",
      },
      button: {
        padding: "12px 24px",
        backgroundColor: "#e72424",
        color: "white",
        fontWeight: "bold",
        borderRadius: "4px",
        border: "none",
        cursor: "pointer",
        textDecoration: "none",
        margin: "10px",
      },
      waitlistButton: {
        padding: "12px 24px",
        backgroundColor: "#e72424",
        color: "white",
        fontWeight: "bold",
        borderRadius: "4px",
        border: "none",
        cursor: "pointer",
        textDecoration: "none",
        margin: "10px",
      },
      "@media (max-width: 440px)": {
        buttonContainer: {
          flexDirection: "column",
        },
      },
      text: {
        fontSize: "16px",
        lineHeight: "1.6",
        color: "#333",
      },
      statusMessage: {
        fontSize: "18px",
        color: partecipa === 1 ? "#4CAF50" : "#e72424",
        margin: "20px 0",
        fontWeight: "bold",
      },
    };

    if (isLoading) {
      return <div>Loading...</div>;
    }

    const [day, month, year] = data.split("/");
    const eventDate = new Date(`${year}-${month}-${day}`);

    const currentDate = new Date();

    let message;
    if (eventDate < currentDate) {
      message = (
        <p style={styles.statusMessage}>
          Questo evento è già passato. Se hai bisogno di ulteriori informazioni,
          contatta l'organizzatore.
        </p>
      );
    } else if (partecipa === 1) {
      message = <p style={styles.statusMessage}>Hai già accettato l'invito.</p>;
    } else if (partecipa === -1) {
      message = <p style={styles.statusMessage}>Hai già rifiutato l'invito.</p>;
    } else if (lista_attesa === 1) {
      message = (
        <p style={styles.statusMessage}>
          Sei stato inserit* in lista d'attesa, qualora dovesse liberarsi un
          posto verrai aggiornat* tramite app.
        </p>
      );
    }

    const isFull = n_partecipanti >= n_partecipanti_max;

    return (
      <div style={styles.container}>
        {titolo ? (
          <table style={styles.table}>
            <tr>
              <td>
                <h1 style={styles.heading}>Invito all'evento: {titolo}</h1>
                {message}
                {!message && (
                  <>
                    <p style={styles.subHeading}>
                      Ciao {nome}, sei stato invitato a partecipare all'evento{" "}
                      <strong>{titolo}</strong>.
                    </p>
                    <p style={styles.text}>
                      L'evento si terrà il <strong>{data}</strong> alle ore{" "}
                      <strong>{orario}</strong>.
                      <br />
                    </p>

                    {descrizione && (
                      <p
                        style={styles.text}
                        dangerouslySetInnerHTML={{ __html: descrizione }}
                      ></p>
                    )}

                    {locandina && (
                      <div>
                        <img
                          src={locandina}
                          alt="Locandina dell'evento"
                          style={{ width: "50%", marginBottom: "20px" }}
                        />
                      </div>
                    )}

                    {isFull ? (
                      <>
                        <p style={styles.text}>
                          Purtroppo non ci sono più posti liberi per questo
                          evento. Puoi prenotare il tuo posto in lista cliccando
                          il pulsante qui sotto.
                        </p>
                        <div style={styles.buttonContainer}>
                          <a
                            style={styles.waitlistButton}
                            onClick={this.handleLista}
                          >
                            Prenota il tuo posto in lista
                          </a>
                        </div>
                      </>
                    ) : (
                      <div style={styles.buttonContainer}>
                        <a style={styles.button} onClick={this.handleAccept}>
                          Accetta l'invito
                        </a>
                        <a
                          style={{ ...styles.button, backgroundColor: "gray" }}
                          onClick={this.handleReject}
                        >
                          Rifiuta l'invito
                        </a>
                      </div>
                    )}
                  </>
                )}
                {lista_attesa === 1 && (
                  <div style={styles.buttonContainer}>
                    <a style={styles.button} onClick={this.handleRemoveLista}>
                      Rimuovi dalla lista d'attesa
                    </a>
                  </div>
                )}
              </td>
            </tr>
          </table>
        ) : (
          <p>Non ci sono dettagli disponibili per l'evento.</p>
        )}
      </div>
    );
  }
}

export default EventResponse;
